import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { DwMenuHelperService, DwMenuService, DwMenuServiceState, DwSecurityUserService } from '@devwareapps/devware-cap';
import { environment } from 'src/environments/environment';
import { AppPermissions } from '../../meta-data/app-permissions.enum';
import { PilexosUser } from '../../features/shared/models/pilexos-user.model';
import { PilexosUserTypeIds } from '../../features/shared/models/pilexos-user-type.enum';
import { ExaminerRepositoryService } from '../../features/examiner/services/examiner-repository.service';
import { PilotExaminerStatusAllItems } from '../../meta-data/app-meta-data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  showLayout: boolean = true;

  showSlashScreen: boolean = true;
  environmentMessage: string;
  scrolled = false;

  themeClasses: string;
  lastExaminer: import("c:/Projects/DevwareGit/Pilexos/PilexosCAPAngular/src/app/meta-data/app-meta-data.service").PilotExaminerEntity;

  constructor(
    private router: Router,
    private menuService: DwMenuService,
    private menuHelperService: DwMenuHelperService,
    private dwSecurityUserService: DwSecurityUserService,
    private examinerRepository: ExaminerRepositoryService
  ) {
    this.environmentMessage = environment.environmentMessage;
  }

  ngOnInit(): void {

    setTimeout(() => {
      this.showSlashScreen = false;
    }, 200);

    document.addEventListener("scroll", (ev) => {
      let document = ev.target as any;
      if (document.scrollingElement.scrollTop > 50) {
        if (!this.scrolled) {
          this.scrolled = true;
          this.setTheme(this.menuService.menuState);
        }
      }
      else {
        if (this.scrolled) {
          this.scrolled = false;
          this.setTheme(this.menuService.menuState);
        }
      }
    });

    

    this.menuService.menuStateObservable
      .subscribe(menuState => {
        this.setTheme(menuState);
      })

    this.setTheme(this.menuService.menuState);
  }


  private checkPilotExaminerSecurity(menuState: DwMenuServiceState) {
    if (!(menuState?.currentMenu?.url?.indexOf('/settings')>=0)) {
      return;
    }

    const user = this.dwSecurityUserService.securityContext?.ApplicationUser;
    
    if (!user) {
      return;
    }
    
    if (this.dwSecurityUserService.hasPermission(AppPermissions.pilexosUserTypeLimitedMenusCanSeeAll)) {
      return;
    }
    
    console.log('Checking security for pilot examiner');

    var pilexosUser = new PilexosUser(user);

    if (pilexosUser.UserTypeId != PilexosUserTypeIds.pilotExaminer) {
      this.router.navigate(['/']);
    }

    const menu = this.menuService.menuState.currentMenu;

    console.log('Current Menu', menu);

    if (!menu) {
      console.log('menu not found');
    }

    if (!this.menuHelperService.canAccessMenu(menu)) {
      this.router.navigate(['/']);
    }

    if (!menu.data.visibleRuleResult) {
      this.router.navigate(['/']);
    }

    if (this.lastExaminer?.UserId == user?.UserId) {
      if ((this.lastExaminer.PilotExaminerStatusId == PilotExaminerStatusAllItems.VerifiedLive) || (this.lastExaminer.PilotExaminerStatusId == PilotExaminerStatusAllItems.Inactive)) {
        return;
      }
      this.router.navigate(['/']);

      return;
    }

    this.examinerRepository.getCurrentPilotExaminer()
      .subscribe(examiner => {

        this.lastExaminer = examiner;
        
        if ((examiner.PilotExaminerStatusId == PilotExaminerStatusAllItems.VerifiedLive) || (examiner.PilotExaminerStatusId == PilotExaminerStatusAllItems.Inactive)) {
          return;
        }
        this.router.navigate(['/']);
      })
    
  }

  private setTheme(menuState: DwMenuServiceState) {
    this.checkPilotExaminerSecurity(menuState);
  
    // deselect text

    const currentMenu = menuState.currentMenu;

    let themeClass = Themes.home;

    if (!currentMenu) {
      this.themeClasses = themeClass;

      if (this.scrolled) {
        this.themeClasses += ',scrolled';
      }

      return;
    }

    themeClass = Themes.main;

    if (currentMenu.url?.indexOf('admin') >= 0) {
      themeClass = Themes.admin;
    }

    if (currentMenu.data?.referenceKey == 'home') {
      themeClass = Themes.home;
    }

    this.themeClasses = themeClass;

    if (this.scrolled) {
      this.themeClasses += ',scrolled';
    }

    //this.deselectText();
  }

  private deselectText() {
    try {
      if (window.getSelection) { 
        window.getSelection().removeAllRanges(); 
      }
      else 
      if ((document as any).selection) { 
        (document as any).selection.empty(); 
      }
    }
    catch(e) {

    }
  }

  ngOnDestroy(): void {
    document.removeEventListener("scroll", (ev) => { });
  }
}


enum Themes {
  home = 'home-theme',
  main = 'main-theme',
  admin = 'admin-theme'
}
